/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useMemo, useEffect } from 'react';
import { isEmpty } from 'lodash-es';
import { useLocation } from 'react-router-dom';
import { setSavedURLParams } from '../utils/saved-url-params';

export const useSetSavedURLParams = () => {
  const { search } = useLocation();

  const params = useMemo(() => {
    try {
      return [...new URLSearchParams(search).entries()];
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return [];
    }
  }, [search]);

  useEffect(() => {
    if (!isEmpty(params)) {
      setSavedURLParams(params);
    }
  }, [params]);
};
